// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__OPvGY","title":"ClientInsurance_title__1_-PV","itemText":"ClientInsurance_itemText__2R5rq"};